import { queryServices } from '@wix/ambassador-bookings-services-v2-service/http';
import { FIELD_TYPES } from '../../constants';
import { uoUWidgetLoadOnLiveSiteSrc187Evid8 } from '@wix/bi-logger-bookings-data/v2';
const serviceSorter = (a, b) => {
  var _a$category, _b$category;
  return (((_a$category = a.category) == null ? void 0 : _a$category.sortOrder) ?? 0) - (((_b$category = b.category) == null ? void 0 : _b$category.sortOrder) ?? 0) || (a.sortOrder ?? 0) - (b.sortOrder ?? 0);
};
export const fetchServices = _ref => {
  let {
    httpClient: _httpClient,
    errorHandler
  } = _ref;
  return async _ref2 => {
    let {
      serviceIds
    } = _ref2;
    try {
      var _response$data$servic;
      const response = await errorHandler.withErrorHandler(() => _httpClient.request(queryServices({
        query: serviceIds ? {
          filter: {
            id: {
              $in: serviceIds
            }
          }
        } : {}
      })), {
        errorCodesMap: {}
      });
      return (_response$data$servic = response.data.services) == null ? void 0 : _response$data$servic.sort(serviceSorter);
    } catch (e) {
      const resolvedError = errorHandler.getResolvedError(e);
      console.error(resolvedError);
      return undefined;
    }
  };
};
export const loadInitialServicesDropdownData = async (httpClient, errorHandler, _wixCodeApi, _formId, form, environment, biLogger) => {
  var _form$fields;
  if (environment.isEditor) {
    return {
      services: []
    };
  }
  const serviceIds = (_form$fields = form.fields) == null ? void 0 : _form$fields.filter(field => {
    var _field$view;
    return ((_field$view = field.view) == null ? void 0 : _field$view.fieldType) === FIELD_TYPES.SERVICES_DROPDOWN;
  }).map(field => {
    var _field$view2;
    return (_field$view2 = field.view) == null || (_field$view2 = _field$view2.options) == null ? void 0 : _field$view2.map(option => option.id);
  }).flat();
  try {
    var _services$data, _services$data$servic;
    const services = await errorHandler.withErrorHandler(() => httpClient.request(queryServices({
      query: serviceIds ? {
        filter: {
          id: {
            $in: serviceIds
          }
        }
      } : {}
    })), {
      errorCodesMap: {}
    });
    const activeServiceIds = services == null || (_services$data = services.data) == null || (_services$data = _services$data.services) == null ? void 0 : _services$data.map(service => service.id);
    if (activeServiceIds != null && activeServiceIds.length) {
      biLogger == null || biLogger.report(uoUWidgetLoadOnLiveSiteSrc187Evid8({
        widgetName: 'service-dropdown',
        servicesIds: activeServiceIds.join(','),
        environment: JSON.stringify(environment)
      }));
    }
    return {
      services: (_services$data$servic = services.data.services) == null ? void 0 : _services$data$servic.sort(serviceSorter)
    };
  } catch (e) {
    const resolvedError = errorHandler.getResolvedError(e);
    console.error(resolvedError);
    throw resolvedError;
  }
};
//# sourceMappingURL=fetch-services.js.map